// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlighted-cams[data-v-7d765896]{background:#ddd;border:1px solid #3d3d3d;border-radius:8px;height:-moz-max-content;height:max-content;padding:20px}.highlighted-cams__content[data-v-7d765896]{display:grid;grid-gap:20px;gap:20px}.highlighted-cams__title[data-v-7d765896]{color:#000;font-size:.9em;margin-bottom:5px}.highlighted-cams__icon[data-v-7d765896]{font-size:.8em;margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
